// extracted by mini-css-extract-plugin
export default {"root":"sticky_item-module___root___bd2579cf"};